module.exports = __webpack_public_path__ + "img/remove.475ec8ee.png";